<template>
    <div class="previewbooking">
        <PreviewBookingComponent></PreviewBookingComponent>
    </div>
</template>


<script>
    import PreviewBookingComponent from '@/components/cust_components/previewBooking_component.vue';

    export default {
        name: 'viewBooking',
        data() {
            return {
            }
        },
        components: {
            PreviewBookingComponent
        }

    }
</script>